import { connectRouter } from 'connected-react-router'
import { reducer as formReducer } from 'redux-form'
import { Reducer as modalRootReducer } from 'components/Modal'
import AuthReducer from 'modules/Auth/store/reducer'
import notificationsReducer from 'modules/Notifications/store/reducer'
import appReducer from 'modules/App/store/reducer'
import { FormsReducers } from 'modules/Forms'

export const getStaticReducers = (history) => ({
  router: connectRouter(history),
  modal: modalRootReducer,
  auth: AuthReducer,
  notifications: notificationsReducer,
  form: formReducer,
  app: appReducer,
  ...FormsReducers,
})
